module.exports = __webpack_public_path__ + "media/logos/Public Art Management 1-8bb90163.svg";